<template>
  <div class="add-content container">
    <form class="card-panel" @submit.prevent="makeContent">
      <h2 class="center cyan-text text-darken-1">部屋を作る</h2>
      <div class="field">
        <label for="title">タイトル</label>
        <input id="title" type="text" v-model="title">
      </div>
      <div class="field">
        <label for="description">簡単な説明</label>
        <input id="description" type="text" v-model="description">
      </div>
      <label for="picked">いずれか選択しタッチしてください</label>
      <br>
        <input type="radio" id="one" value="AmazonPrime" v-model="picked">
          <label class="choice cyan-text text-darken-1" for="one">AmazonPrime</label>
          <br>
        <input type="radio" id="two" value="Netflix" v-model="picked">
          <label class="choice cyan-text text-darken-1" for="two">Netflix</label>
          <br>
        <input type="radio" id="three" value="Hulu" v-model="picked">
          <label class="choice cyan-text text-darken-1" for="three">Hulu</label>
          <br>
      <p>配信: {{ picked }}</p>



      <p v-if="feedback" class="red-text center">{{ feedback }}</p>
      <div class="field center">
        <button class="btn cyan darken-1">Go!</button>
      </div>
    </form>
  </div>
</template>

<script>
import slugify from 'slugify'
import firebase from 'firebase'
import db from '@/firebase/init'

export default {
  name: 'AddContent',
  data(){
    return{
      title: null,
      description: null,
      slug: null,
      feedback: null,
      picked: null,

    }
  },
  methods: {
    makeContent(){
      if(this.title && this.description && this.picked){

      this.slug = slugify(this.title, {
               replacement: '-',
               remove: /[$*_+~.()'"!\-:@]/g,
             });

        db.collection('contents').add({
          title: this.title,
          description: this.description,
          slug: this.slug,
          time: Date.now(),
          picked: this.picked,
        }).then(() => {
          this.$router.push({ name: 'Content', params:{ slug: this.slug }})
        })
      } else {
      this.feedback = '全てに記入と選択してね'
    }
  }
}
}
</script>

<style>
.add-content {
  max-width: 400px;
  margin-top: 60px;
}
.add-content h2{
  font-size: 2.4em;
}
.add-content .field{
  margin-bottom: 16px;
}
.choice{
  font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/AddContent.vue